<template>
  <div class="confirmed-driver-info">
    <div class="agent agent--courier">
      <div class="agent__preview">
        <div class="agent__avatar agent__preview__avatar--courier">
          <div class="img" :style="backgroundImageStyle"></div>
        </div>
        <div class="agent__preview__rate">
          <i class="icon agent__preview__rate__icon">
            <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.082 4.078c-.16-.154-.073-.434.143-.46l3.055-.38a.256.256 0 00.2-.154L4.77.155a.25.25 0 01.461 0l1.289 2.93a.255.255 0 00.2.152l3.055.38c.216.027.302.307.143.461L7.66 6.268a.275.275 0 00-.077.248l.6 3.164c.042.224-.185.397-.374.285L5.124 8.39a.244.244 0 00-.248 0L2.192 9.966c-.19.111-.417-.061-.374-.285l.6-3.164a.275.275 0 00-.078-.247L.082 4.079z" fill="#FFCF23"/></svg>
          </i>
          <p class="agent__preview__rate__value">{{ rating }}</p>
        </div>
      </div>
      <div class="agent__info">
        <div class="agent__info__title">
          <div class="agent__info__title">
            <p v-for="(driverName, index) in splitName.slice(0, 3)" :key="index">{{ driverName }}</p>
          </div>
        </div>
      </div>
    </div>
    <copay-block style="flex-direction: column-reverse; align-items: flex-start;"></copay-block>
  </div>
</template>

<script>
import driverIcon from '@/assets/img/driver.png'
import { mapGetters } from 'vuex'
import CopayBlock from '@/components/_common/copay-block.vue'

export default {
  name: 'staff-block-qr',
  components: {
    CopayBlock,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    rate: {
      type: Number,
      required: true,
    },
    avatar: {
      type: String,
      required: true,
    },
  },
  // ['name', 'rate', 'avatar'],
  data() {
    return {
      isTooltipActive: false,
      isPaymentOverlayOpen: false,
      driverIcon,
    }
  },
  computed: {
    ...mapGetters(['orderData']),
    rating() {
      const rate = Number(this.rate)
      if (rate < 9) {
        return 4.8
      }
      return (this.rate / 2).toFixed(1)
    },
    backgroundImageStyle() {
      let avatarUrl = this.avatar

      if (!this.avatar || this.avatar === '/assets/common/img/temp/avatars/1.jpg') {
        avatarUrl = this.driverIcon
      }

      return {
        backgroundImage: `url(${avatarUrl})`,
      }
    },
    splitName() {
      return this.name.split(' ')
    },
  },
  methods: {
    toggleTooltip() {
      this.isTooltipActive = !this.isTooltipActive
    },
  },
}
</script>
